"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateIntermediateFields = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const validateIntermediateFields = ({ intermediateFields, queryResultVariables, }) => {
    const errors = [];
    const variableSet = new Set();
    const intermediateFieldSet = new Set();
    queryResultVariables.forEach((queryResultVariable) => {
        if (variableSet.has(queryResultVariable)) {
            errors.push(`Duplicate query result variable: ${queryResultVariable}`);
        }
        else {
            variableSet.add(queryResultVariable);
        }
    });
    intermediateFields.forEach(({ config, field }) => {
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(config.formula, variableSet);
        formulaErrors.errorMessages.forEach((errorMessage) => {
            errors.push(`Error in intermediate field: ${field}. Error: ${errorMessage}`);
        });
        if (field === '') {
            errors.push('Intermediate field name is empty.');
        }
        if (variableSet.has(field)) {
            errors.push(`Duplicate intermediate field / query variable name: ${field}`);
        }
        else {
            variableSet.add(field);
            intermediateFieldSet.add(field);
        }
    });
    finley_types_1.CreditAgreement.Config.PortfolioCovenant.RequiredIntermediateFieldIterable.forEach((requiredField) => {
        if (!intermediateFieldSet.has(requiredField)) {
            errors.push(`Intermediate fields are missing required field ${requiredField}`);
        }
    });
    return errors;
};
exports.validateIntermediateFields = validateIntermediateFields;
//# sourceMappingURL=intermediateField.js.map